
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'

import { _FadeInOnMount } from './styles'

const FadeInOnMount = (
  {
    timeout = 0,
    type,
    children,
  },
) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(true)
    return () => setShow(false)
  }, [])

  return (
    <_FadeInOnMount>
      <CSSTransition
        unmountOnExit
        appear
        exit
        in={show}
        timeout={timeout}
        classNames={type}
      >
        <div>
          {children}
        </div>
      </CSSTransition>
    </_FadeInOnMount>
  )
}

FadeInOnMount.propTypes = {
  timeout: PropTypes.number,
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.element)]),
}
export default FadeInOnMount
